// ICE/TURN server configuration, always fetched from the backend (never hardcoded).
// Replaces the old Redux LoaderReducer.turnDetails that peer.service read at
// connection-creation time.
import { httpRequest } from './http'

let iceConfig: any = null

export const setIceConfig = (config: any) => {
  iceConfig = config
}

export const getIceConfig = () => iceConfig

// GET /serverDetails/iceserver -> { status, webIceConfig: { iceServers: [...] } }
export const fetchIceConfig = async (): Promise<any> => {
  try {
    const response = await httpRequest('serverDetails/iceserver', 'GET')
    if (response?.status === 'success' && response?.webIceConfig) {
      setIceConfig(response.webIceConfig)
      return response.webIceConfig
    }
  } catch (error) {
    console.error('Error fetching ICE server details:', error)
  }
  return null
}
